import { render, staticRenderFns } from "./ComplianceOutstandingActionsDrillDown.vue?vue&type=template&id=24e1d626&"
import script from "./ComplianceOutstandingActionsDrillDown.vue?vue&type=script&lang=ts&"
export * from "./ComplianceOutstandingActionsDrillDown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports